<template>
  <div v-if="Object.keys(dataInfo).length > 0" class="out_container">
    <div class="topView">
      <div class="leftView">{{ dataInfo.remindContent }}</div>
      <div class="rightView">{{ getStatusName(statusList, dataInfo.sendStatus) }}</div>
    </div>
    <div class="contentView">
      <div class="info">朋友圈内容：</div>
      <div class="title">{{ dataInfo.title }}</div>
      <div v-if="dataInfo.contentList && dataInfo.contentList.length > 0">
        <!--            图片-->
        <div v-if="dataInfo.mediaType == '21'" class="content">
          <div class="item" v-for="(item,index) in dataInfo.contentList" :key="index">
            <img v-if="item.picUrl && item.picUrl != ''" :src="item.picUrl" class="picImg" @click="handlePreview(index)"/>
          </div>
        </div>
        <!--            视频-->
        <div v-if="dataInfo.mediaType == '24'" class="content">
          <div class="item" v-for="(item,index) in dataInfo.contentList" :key="index" @click="handleClick(item)">
            <video v-if="item.picUrl && item.picUrl != ''" ref="listVideo" preload="auto" :controls="false" class="picImg">
              <source :src="videoUrl" type="video/mp4"/>
              您的系统不支持 video 标签。
            </video>
            <img v-if="item.picUrl && item.picUrl != ''" src="../../assets/qwPyq/play@2x.png" class="playBtn">
          </div>
        </div>
        <!--            图文链接-->
        <div v-if="dataInfo.mediaType == '22'">
          <div class="rowContent" v-for="(item,index) in dataInfo.contentList" :key="index">
            <img :src="item.picUrl" class="rowImg" @click="handlePreview(index)"/>
            <div class="contentInfo">
              <div class="contentTitle one-text">{{ item.title }}</div>
              <div class="contentLink one-text">{{ item.pageUrl }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomView" v-if="dataInfo.sendStatus == 50">
      <div class="submitBtn" @click="handleSubmit">前往发送</div>
    </div>
    <van-popup
      v-model="playVideo"
      class="express-popup"
      :safe-area-inset-bottom="true"
      closeable
      :close-on-click-overlay="false"
      @close="handleClose"
      style="width: 100vw"
    >
      <video v-if="!isNullData(videoUrl)" ref="video" style="width:100%;"  autoplay="autoplay" preload  controls="controls">
        <source :src="videoUrl" type="video/mp4"/>
        您的系统不支持 video 标签。
      </video>
    </van-popup>
  </div>
</template>

<script>
import {initWxConfig, shareToExternalMoments} from "../../utils/weixin";
import http from "@/utils/axios";
import { ImagePreview  } from "vant";
import utils from "@/utils/common";
export default {
  data() {
    return {
      id: '',
      wx: null,
      dataInfo: {},
      playVideo:false,
      videoUrl:'',
      postUrl:'',
      statusList: [
        {
          value: '',
          name: '全部'
        },
        {
          value: 100,
          name: '已发送'
        },
        {
          value: 50,
          name: '待发送'
        },
        {
          value: 998,
          name: '无法发送[内部错误]'
        },
        {
          value: 400,
          name: '无法发送'
        },
        {
          value: 999,
          name: '已取消'
        }
      ],
    }
  },
  created() {
    this.id = this.$route.query.id
    console.log(`wxObject====`,this.$wx)
    this.getDetailInfo()
  },
  mounted() {

  },
  methods: {
    getDetailInfo() {
      http({
        url: "order/dmp/ewMassTextingFriendCircle/getMsgAttachmentByCircleId",
        method: "post",
        parmes: {
          circleId:this.id
        }
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          let contentList = data.attachmentVoList
          if (contentList && contentList.length > 0) {
            contentList.forEach((item) => {
              item.mediaType = item.type
              if (!this.isNullData(item.picUrl)) {
                item.mediaUrl = item.picUrl
              }
            })
            let item = contentList.find((item) => {
              return item.mediaType == 11
            })
            if (!this.isNullData(item)) {
              data.title = item.content
            }
            let index = contentList.findIndex((item) => {
              return item.mediaType == 11
            })
            if (index > -1) {
              contentList.splice(index, 1)
            }
            if(contentList.length > 0){
              data.mediaType = contentList[0].mediaType
              if(data.mediaType == 24){
                this.videoUrl = contentList[0].picUrl
              }
            }
          }
          data.contentList = contentList
          this.dataInfo = data
          if(data.mediaType == 24){
            this.$nextTick(() => {
              console.log(this.$refs.listVideo[0])
              this.$refs.listVideo[0].load();
            })
          }
        }else{
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    isNullData(data) {
      if (data !== '' && data !== null && typeof data !== 'undefined' && data !== '{}' && data !== {} && data !==
          '[]' && data !== 'null' && data != '无') {
        return false;
      }
      return true;
    },
    getStatusName(obj, status) {
      let arr = !this.isNullData(status) ? obj.filter((item) => {
        return item.value == status
      }) : []
      let name = arr.length > 0 ? arr[0].name : ''
      return name
    },
    // 前往发送
    handleSubmit() {
      this.$loading.show();
      let contentList = []
      if(this.dataInfo.mediaType == 21){// 图片
        this.dataInfo.contentList.forEach((item) => {
          let obj = {
            msgtype: "image",    // 消息类型，必填
            image: {
              // imgUrl: item.picUrl,        // 图片的imgUrl,跟图片mediaid填其中一个即可
              mediaid:item.mediaId,
            }
          }
          contentList.push(obj)
        })
      }else if(this.dataInfo.mediaType == 24){// 视频
        this.dataInfo.contentList.forEach((item) => {
          let obj = {
            msgtype: "video",    // 消息类型，必填
            video:{
              mediaid:item.mediaId,        // 视频的素材id
            },
          }
          contentList.push(obj)
        })
      }else if(this.dataInfo.mediaType == 22){// 图文
        this.dataInfo.contentList.forEach((item) => {
          let obj = {
            msgtype: "link",    // 消息类型，必填
            link: {
              title: item.title,        // H5消息标题
              imgUrl: item.picUrl,    // H5消息封面图片URL
              url: item.pageUrl,        // H5消息页面url 必填
            },
          }
          contentList.push(obj)
        })
      }
      initWxConfig(this.id,location.href, this.$wx).then((wx) => {
        this.wx = wx;
        console.log('发送内容====')
        console.log(this.dataInfo.title)
        console.log(contentList)
        shareToExternalMoments(this.wx, this.dataInfo.title, contentList).then((res) => {
          this.$loading.hide();
          console.log('已发送')
          console.log(res)
          // this.getDetailInfo()
          this.sendSuccessProcess()
        }).catch((err) => {
          this.$loading.hide();
          console.log('发送失败=============')
          console.log(err)
          if(err == 'shareToExternalMoments:cancel'){
            this.$toast('已取消发表')
          }else{
            this.$toast('发送失败，请稍后重试')
          }
        })
      }).catch((err) => {
        this.$loading.hide();
        this.$toast('发送失败，请稍后重试')
        console.log('wx注册失败=====')
        console.log(err)
      })
    },
    sendSuccessProcess(){
      http({
        url: "order/dmp/ewMassTextingFriendCircle/sendSuccessProcess",
        method: "post",
        parmes: {
          circleId:this.id
        }
      }).then(rps => {
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
      });
    },
    // 图片预览
    handlePreview(index){
      let list = this.dataInfo.contentList.map((item) => {
        return item.picUrl
      })
      ImagePreview({
        images: list,
        startPosition: index,
        closeable: true
      })
    },
    // 播放视频
    handleClick(item){
      if(item.picUrl != ''){
        // this.videoUrl = item.picUrl
        // this.playVideo = true
        // this.$nextTick(() => {
        //   this.$refs.video.play()
        // })
        utils.jumpToNewPage({
          url:
              location.origin +
              "/h5user/videoDetail?url=" +
              item.picUrl,
          noTitle: "1"
        });
      }
    },
    handleClose(){
      this.$refs.video.pause()
      this.videoUrl = ''
      this.playVideo = false
    },
    onclickplay(){
      this.$refs.video.play()
    }
  }
}
</script>

<style lang="less" scoped>
.out_container {
  background: #ffffff;
  padding: 40px 30px calc(constant(safe-area-inset-bottom) + 20px) 30px;
  padding: 40px 30px calc(env(safe-area-inset-bottom) + 20px) 30px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  .btn {
    background: #4871C1;
    border-radius: 10px;
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
  }
  .topView {
    padding: 20px 20px;
    background: #F1F9FF;
    border-radius: 10px;
    display: flex;

    .leftView {
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      margin-right: 30px;
      white-space: normal;
      word-break: break-all;
    }

    .rightView {
      min-width: 86px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      border: 1px solid #F8A651;
      font-size: 22px;
      font-weight: 400;
      color: #F8A651;
    }
  }

  .contentView {
    margin-top: 40px;
    padding-bottom:calc(constant(safe-area-inset-bottom) + 120px);
    padding-bottom:calc(env(safe-area-inset-bottom) + 120px);
    .info {
      font-size: 28px;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
      margin-bottom: 20px;
    }

    .title {
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      white-space: normal;
      word-break: break-all;
      margin-bottom: 40px;
    }

    .content {
      background: #F7F7F7;
      border-radius: 10px;
      padding: 20px 20px;
      display: flex;
      flex-wrap: wrap;
      row-gap: 20px;
      column-gap: 25px;

      .item {
        width: 30%;
        height: 0;
        padding-top: 30%;
        border-radius: 10px;
        position: relative;

        .picImg {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }

        .playBtn {
          position: absolute;
          top: calc(50% - 30px);
          left: calc(50% - 30px);
          width: 60px;
          height: 60px;
          z-index: 999;
        }
      }
    }

    .rowContent {
      background: #F7F7F7;
      border-radius: 10px;
      padding: 20px 20px;
      display: flex;
      align-items: center;

      .rowImg {
        width: 100px;
        height: 100px;
        border-radius: 10px;
        margin-right: 20px;
        object-fit: cover;
      }

      .contentInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: calc(100% - 120px);
        .contentTitle {
          font-size: 28px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-bottom: 5px;
        }

        .contentLink {
          font-size: 24px;
          font-weight: 400;
          color: #999999;
          line-height: 33px;
        }

        .one-text {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          word-break: break-all;
          word-wrap: break-word;
        }
      }
    }
  }

  .bottomView {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 20px calc(constant(safe-area-inset-bottom) + 20px) 20px;
    padding: 20px 20px calc(env(safe-area-inset-bottom) + 20px) 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;

    .submitBtn {
      background: #4871C1;
      border-radius: 10px;
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-weight: 500;
      color: #FFFFFF;
    }
  }
  .express-popup {
    background-color: transparent;
    .content {
      height: 100vh;
      position: relative;
    }
    .box {
      border-radius: 20px 20px 0 0;
      background-color: #fff;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
    }
    /deep/.div-b {
      box-shadow: none;
      overflow: visible;
    }
    .border-bottom {
      height: 1PX;
      background-color: #ebedf0;
      transform: scaleY(.5);
      width: 626px;
      margin: 0 auto;
    }
    .submit {
      text-align: center;
      padding: 16px 0;
    }
    .van-button {
      border-radius: 50px;
      font-size: 26px;
      font-weight: bold;
      color: #333!important;
      width: 600px;
    }
  }
}
</style>
